export enum SingleMediaLibraryTabs {
    REPORTS = 'reports',
    IN_PLAYLIST = 'in-playlist',
    PLAYING_WHERE = 'playing-where',
    HISTORY = 'history',
}
